import React from "react";
import "./Academia.css";

import presupuesto from "../../Assets/Academy/presupuesto.webp";
import taller from "../../Assets/Academy/taller.webp";
import clases from "../../Assets/Academy/clases.webp";

const Services = () => {
   const services = [
      {
         tag: "OPTIMIZACIÓN DE PRESUPUESTO",
         title: "Asesoría de Compra",
         desc: "No compres a ciegas. Te diseño el kit perfecto según tu presupuesto para que cada euro cuente.",
         img: presupuesto,
      },
      {
         tag: "DOMINIO TÉCNICO",
         title: "Taller de Configuración",
         desc: "Trae tu dron y lo dejamos listo para volar. Ajuste de PID, Rates y configuración de Failsafe en Betaflight.",
         img: taller,
      },
      {
         tag: "CLASES DE VUELO",
         title: "Clases de Vuelo",
         desc: "Aprende directamente conmigo. Desde lo básico hasta técnicas avanzadas de vuelo cinemático profesionales paso a paso.",
         img: clases,
      },
   ];

   return (
      <section className="services-section">
         <div className="ruta-header">
            <h2 className="ruta-title">
               Tu Ruta al <span>Vuelo Perfecto</span>
            </h2>
            <p className="ruta-subtitle">
               Elige el camino que mejor se adapte a tus necesidades. Desde la
               elección de piezas hasta tu primer vuelo cinemático.
            </p>
         </div>
         <div className="cards-wrapper">
            {services.map((service, index) => (
               <div
                  className="service-card"
                  key={index}
                  style={{ backgroundImage: `url(${service.img})` }}
               >
                  <div className="card-overlay">
                     <span className="card-tag">{service.tag}</span>
                     <div className="card-body">
                        <h3 className="card-title-service">{service.title}</h3>
                        <p className="card-description-service">
                           {service.desc}
                        </p>
                     </div>
                  </div>
               </div>
            ))}
         </div>

         <div className="results-header">
            <h2 className="results-title">RESULTADOS CINEMATOGRÁFICOS</h2>
            <p className="results-quote">
               Si soy capaz de entregar estos planos a productoras y marcas de
               primer nivel, puedo enseñarte a ti a dominar la fluidez en
               cualquier entorno.
            </p>
            <p className="results-sub">
               Explora proyectos reales de mi portfolio y descubre el estándar
               visual que vas a alcanzar.
            </p>
         </div>
      </section>
   );
};

export default Services;
